__turbopack_context__.v({
  "icon": "LegacyLogo-module-scss-module__F2rG0a__icon",
  "logo": "LegacyLogo-module-scss-module__F2rG0a__logo",
  "wordmark": "LegacyLogo-module-scss-module__F2rG0a__wordmark",
});
